import type { EvListSort } from "@/features/ev/EvListSort";
import type { EvProductType } from "@/features/ev/EvProductType";
import type { EvSetType } from "@/features/ev/EvSetType";
import type { Money } from "@/lib/domain/Money";
import { useHTTP, type PaginatedResponseModel } from "@/lib/http";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export interface EvItemResponseModel {
	readonly setType: EvSetType;
	readonly productType: EvProductType;
	readonly productId: string;
	readonly productImage: string;
	readonly productName: string;
	readonly fcId: string;
	readonly currentEstimatedValue: Money;
	readonly marketPrice: Money;
	readonly marketPriceDelta: Money;
	readonly warning: string | null;
}

export const useEvItems = (sort: EvListSort, productType: EvProductType) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["ev", sort, productType],
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<EvItemResponseModel>>({
				method: "GET",
				url: `/ev/list?sort=${sort}&cursor=${pageParam}` + (productType !== "All" ? `&productType=${productType}` : "")
			});
		}
	});
};
